import React from 'react';

import { ListFieldValueRenderer } from '@/components/molecules/ListFieldValueRenderer';
import { VerifyBusinessSummaryEntry } from '@/components/molecules/VerifyBusinessSummaryEntry';
import { Field, FieldType } from '@/types/fields';

export const createFieldRenderer = (data: any): ((field: Field<unknown>) => React.ReactNode) =>
  function FieldRenderer(field: Field<unknown>): React.ReactNode {
    const { [field.name]: value = '' } = data ?? {};

    // For embedded fields we need to flatten the child fields
    if (field.type === FieldType.embedded) {
      const { fields } = field;
      return fields.map(createFieldRenderer(data));
    } else if (field.type === FieldType.composite) {
      const { fields } = field;
      return fields.map(createFieldRenderer(data[field.name]));
    } else if (field.type === FieldType.list) {
      return <ListFieldValueRenderer key={field.name} value={value} field={field} />;
    }

    return <VerifyBusinessSummaryEntry key={field.name} value={value} field={field} />;
  };
